import React, { useMemo, useRef } from "react";

import { isEmpty } from "lodash";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import NoResultsGIF from "../../../../../Common/NoResultsGIF";
import LockedContent from "../../../../../grace-period/components/LockedContent";
import { useAccessStatus } from "../../../../../grace-period/hooks/useAccessStatus";
import { QUADRANT_STYLE_MAP } from "../../Constant";
import { checkPinIsPinned } from "../../pinHelper";
import ReportViewHeader from "../ReportViewHeader";
import CorrectiveActionPin from "./CorrectiveActionPin";
import ReportViewPin from "./ReportViewPin";

import pumpkinGIF from "../../../../../../assets/images/environment/pumpkin.gif";
import "./SinglePinMapView.css";

export default function SinglePinMapView({
  imageSrc,
  pin,
  selectedReportTabDate = "",
  correctiveActionPins = {},
}) {
  const { areResultsLocked } = useAccessStatus();
  const imageRef = useRef();
  const pinElementRef = useRef();
  // const correctiveActionPinRefs = useRef([]);

  const correctivePins = useMemo(() => {
    if (!selectedReportTabDate || isEmpty(correctiveActionPins)) return [];
    return correctiveActionPins[selectedReportTabDate];
  }, [selectedReportTabDate, correctiveActionPins]);

  if (pin === undefined) {
    return (<div className="env-analytics-report-view-section env-report-view-map" />);
  }

  const { color, display_name } = checkPinIsPinned(pin)
    ? QUADRANT_STYLE_MAP[pin.quadrant]
    : { color: "var(--color-negative)", display_name: "No location found" }; // red

  const renderMapBody = () => {
    if (areResultsLocked) {
      return (
        <LockedContent
          variant="map"
          title="Map locked"
          description="Complete renewal payment to view this map, pins and location results."
        />
      );
    }
    if (!checkPinIsPinned(pin)) {
      return <NoResultsGIF image={pumpkinGIF} message="Not pinned on the map" />;
    }
    return (
      <TransformWrapper
        disabled
      >
        {({
          zoomToElement,
        }) => (
          <TransformComponent>
            <div>
              <ReportViewPin
                pin={pin}
                pinElementRef={pinElementRef}
                zoomToElement={zoomToElement}
              />
              {!isEmpty(correctivePins) && correctivePins.map((p) => (
                <CorrectiveActionPin
                  key={p.location_id}
                  pin={p}
                // pinElementRef={correctiveActionPinRefs.current[index]}
                // zoomToElement={zoomToElement}
                />
              ))}
              <img
                ref={imageRef}
                alt="swab pin on map"
                src={imageSrc}
                onLoad={() => {
                  if (pinElementRef.current !== null) {
                    zoomToElement(pinElementRef.current, 1);
                  }
                }}
              />
            </div>
          </TransformComponent>
        )}
      </TransformWrapper>
    );
  };

  return (
    <div className="env-analytics-report-view-section env-report-view-map">
      <ReportViewHeader title="Location" subTitle={display_name} subTitleColor={color} blockColor={color === "var(--color-negative)" ? undefined : color} />
      {renderMapBody()}
    </div>
  );
}
